import {
  type CardDraftBulkImport,
  type BulkImportStore,
} from '@/components/BulkImportModal/store/bulk-import.store.types'
import {
  BASE_SHORT_ANSWER_FIELD_VALUES,
  type CardActivityType,
  type CardActivityWithId,
} from '@/models/card-activity/card-activity.model'
import generateCorrectAnswer from '@/utils/generateCorrectAnswer'

export async function enrichShortAnswerCard(
  cardType: CardActivityType,
  cardDraft: CardDraftBulkImport & { id: string },
  settings: BulkImportStore['settings'],
) {
  const baseShortAnswerCard: Partial<CardActivityWithId> = {
    ...BASE_SHORT_ANSWER_FIELD_VALUES,
    id: cardDraft.id,
    type: cardType,
    prompt: cardDraft.prompt,
    language: settings.language,
    default_language: settings.defaultLanguage,
    points: settings.points,
  }

  if (settings.generateAnswers && cardDraft.prompt) {
    const response = await generateCorrectAnswer({
      question: cardDraft.prompt,
      characterLimit: BASE_SHORT_ANSWER_FIELD_VALUES.maxCharacters,
      language: settings.language,
    })

    if ('success' in response && response.success && 'correct_answer' in response) {
      baseShortAnswerCard.correct_answer = response.correct_answer
    }
  }

  return baseShortAnswerCard
}
